import React from 'react'
import { IoIosArrowForward, IoMdClose } from 'react-icons/io'
import { Link } from 'react-router-dom'
import ym from 'react-yandex-metrika'

import { getColorByStationName } from '../../../../helpers/common'
import { ClockIcon } from '../../../icons/ClockIcon'
import { WalkMan } from '../../../icons/WalkMan'
import styles from './mapPopupCard.module.scss'
import { MapPopupCardTypes } from './MapPopupCard.types'

export const MapPopupCard = ({
  data,
  closePopup,
  openPopup,
}: MapPopupCardTypes) => {
  const analytics = () => {
    ym('reachGoal', 'projects click', {
      'projects click main': data.name,
    })
  }

  return (
    <>
      {openPopup && (
        <div>
          <div className={styles.mapPopupBg}>
            <div className={styles.mapPopup}>
              <button className={styles.mapPopupClose} onClick={closePopup}>
                <IoMdClose />
              </button>
              <div className={styles.mapPopupMedia}>
                <img src={data.image} alt={data.name} />
              </div>
              <div className={styles.mapPopupContent}>
                <div className={styles.mapPopupTitle}>{data.name}</div>
                <div className={styles.mapPopupDesc}>
                  {data.metroName && (
                    <div className={styles.mapPopupDescItem}>
                      <div
                        className={styles.dot}
                        style={{
                          background: getColorByStationName(data.metroName),
                        }}
                      />
                      <span>{data.metroName}</span>
                    </div>
                  )}
                  {data.time && (
                    <div
                      className={styles.mapPopupDescItem}
                      style={{ alignItems: 'normal' }}
                    >
                      <WalkMan />
                      <span>{data.time} мин</span>
                    </div>
                  )}
                </div>
                <div className={styles.commissioningBlock}>
                  {data.presentNotReady && <ClockIcon />}
                  <p>
                    {data.presentNotReady && `Сдача в ${data.readyPeriod}`}
                    {data.presentNotReady && data.presentReady ? ', ' : ''}
                    {data.presentReady && 'есть сданные'}
                  </p>
                </div>
                {data.price && (
                  <div className={styles.mapPopupList}>
                    {data.studio?.length ? (
                      <div className={styles.mapPopupListItem}>
                        <p>Студия</p>
                        <p>
                          от{' '}
                          {data.studio?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₽
                        </p>
                      </div>
                    ) : (
                      ''
                    )}
                    {data.rooms1?.length ? (
                      <div className={styles.mapPopupListItem}>
                        <p>1 комн.</p>
                        <p>
                          от{' '}
                          {data.rooms1?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₽
                        </p>
                      </div>
                    ) : (
                      ''
                    )}
                    {data.rooms2?.length ? (
                      <div className={styles.mapPopupListItem}>
                        <p>2 комн.</p>
                        <p>
                          от{' '}
                          {data.rooms2?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₽
                        </p>
                      </div>
                    ) : (
                      ''
                    )}
                    {data.rooms3?.length ? (
                      <div className={styles.mapPopupListItem}>
                        <p>3+ комн.</p>
                        <p>
                          от{' '}
                          {data.rooms3?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₽
                        </p>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                )}
                <Link
                  to={`/project/${data.url_code}`}
                  className={styles.mapPopupLink}
                  onClick={analytics}
                >
                  <span>Подробнее о проекте</span>
                  <IoIosArrowForward />
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
